import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImportsModule } from 'src/app/modules/shared/imports/imports.module';
import { SimuladorComponent } from './components/simulador/simulador.component';
import { TasaPreferencialComponent } from './components/tasaPreferencial/tasaPreferencial.component';
import { EstadoTasasComponent } from './components/estadoTasas/estadoTasas.component';
import { SimuladorRoutingModule } from './simulador-routing.module';

@NgModule({
    declarations: [SimuladorComponent, TasaPreferencialComponent, EstadoTasasComponent],
    imports: [
        CommonModule,
        ImportsModule,
        SimuladorRoutingModule,
    ],
})
export class SimuladorModule { }